import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/JobProgressReport/Filter'

export default createListViewComponent({
  entityName: entityNames.jobProgressReport,
  filterTemplateType: 'JobProgressReport',
  initialFilterDto: (self) => ({ dateRange: { dateRangeType: 'YearToDate' } }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
